import React, {Component} from 'react';
import lang from '../../../constants/Languages.js';
import propTypes from 'prop-types';
import {connect} from 'react-redux';

//import components
import ItemYearbookListItem from './ItemYearbookListItem.js';

class ItemYearbook extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    };

    setYear = (year) => {
        if ((this.state.currentYear && this.state.currentYear.id !== year.id) || !this.state.currentYear) {
            this.setState({currentYear: year});
        }
    };

    resetYear = (year) => {
        this.setState({currentYear: null});
    };

    render() {
        const {clang, years, recordsNumber, cardId} = this.props;
        const {currentYear} = this.state;

        return (
            <div className="card__yearbook">
                <div className="card__yearbook__header" dangerouslySetInnerHTML={{__html: lang[clang].item.yearbook_desc_header}}>
                </div>
                <div className="card__yearbook__list-container">
                    <div className="card__yearbook__list-header">
                        {lang[clang].item.cards.yearbooks}
                        <span className="card__yearbook__list-total">{lang[clang].item.cards.yearbooks_number}: <strong>{recordsNumber}</strong></span>
                    </div>
                    {currentYear && currentYear.reasonOfResignationPublic &&
                        <div className="card__yearbook__alert">
                            <div className="card__yearbook__alert-subsection">
                                <label className="card__yearbook__alert-subsection-label">
                                    {lang[clang].item.cards.yearbooks_warning}:
                                </label>
                                <div className="card__yearbook__alert-subsection-content">
                                    <strong>{lang[clang].item.cards.yearbooks_info}</strong>
                                </div>
                            </div>
                            <div className="card__yearbook__alert-subsection">
                                <label className="card__yearbook__alert-subsection-label">
                                    {lang[clang].item.cards.yearbooks_cause}:
                                </label>
                                <div className="card__yearbook__alert-subsection-content">
                                    {currentYear.reasonOfResignationPublic}
                                </div>
                            </div>
                        </div>}
                    <ul className="card__yearbook__list">
                        {years.map((year, index) =>
                            <ItemYearbookListItem {...year} cardId={cardId} setYear={this.setYear} currentYear={currentYear} resetYear={this.resetYear} key={index}/>)}
                    </ul>
                </div>
            </div>
        );
    };
};

ItemYearbook.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemYearbook);



// WEBPACK FOOTER //
// ./src/components/items/cards/ItemYearbook.js